export default __webpack_public_path__ + "static/media/DouglasHaynes.e51461fb.png";